import types from '../mutation-types';
import ConversationApi from '../../api/inbox/conversation';
import { debounce } from '@chatwoot/utils';

const state = {
  mineCount: 0,
  unAssignedCount: 0,
  urgentCount: 0,
  groupCount: 0,
  pendingCount: 0,
  allCount: 0,
  unreadCount: 0,
};

export const getters = {
  getStats: $state => $state,
};

// Create a debounced version of the actual API call function
const fetchMetaData = async (commit, params) => {
  try {
    const response = await ConversationApi.meta(params);
    const {
      data: { meta },
    } = response;
    commit(types.SET_CONV_TAB_META, meta);
  } catch (error) {
    // ignore
  }
};

const debouncedFetchMetaData = debounce(fetchMetaData, 500, false, 1500);
const longDebouncedFetchMetaData = debounce(fetchMetaData, 5000, false, 10000);
const superLongDebouncedFetchMetaData = debounce(
  fetchMetaData,
  10000,
  false,
  20000
);

export const actions = {
  get: async ({ commit, state: $state }, params) => {
    if ($state.allCount > 5000) {
      superLongDebouncedFetchMetaData(commit, params);
    } else if ($state.allCount > 100) {
      longDebouncedFetchMetaData(commit, params);
    } else {
      debouncedFetchMetaData(commit, params);
    }
  },
  set({ commit }, meta) {
    commit(types.SET_CONV_TAB_META, meta);
  },
};

export const mutations = {
  [types.SET_CONV_TAB_META](
    $state,
    {
      mine_count: mineCount,
      unassigned_count: unAssignedCount,
      urgent_count: urgentCount,
      group_count: groupCount,
      pending_count: pendingCount,
      all_count: allCount,
      unread_count: unreadCount,
    } = {}
  ) {
    if (mineCount !== undefined) $state.mineCount = mineCount;
    if (allCount !== undefined) $state.allCount = allCount;
    if (unAssignedCount !== undefined) $state.unAssignedCount = unAssignedCount;
    if (urgentCount !== undefined) $state.urgentCount = urgentCount;
    if (groupCount !== undefined) $state.groupCount = groupCount;
    if (pendingCount !== undefined) $state.pendingCount = pendingCount;
    if (unreadCount !== undefined) $state.unreadCount = unreadCount;
    $state.updatedOn = new Date();
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
